import { Component } from '@angular/core';

@Component({
  selector: 'app-jobs',
  template: `<jobs-list></jobs-list>`,
})
export class JobsComponent {}
